import { LicenseManager } from 'ag-grid-enterprise'

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()

  LicenseManager.setLicenseKey(config.public.agGridKey)
})
